import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Grid
} from "@mui/material";
import React, { useState } from "react";
import Notify from "../../../Notify";
import { putData } from "../../../../services/library";

function ReabrirPedido(props) {
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [datosformulario, setDatosformulario] = useState(props.dataPedido);
  const [disBtn, setDisBtn] = useState(false)
  async function guardarReabierto(e) {
    setDisBtn(true);
    putData(
      e,
      "/envasado_pedidos/" + datosformulario.id,
      {
        estado: 245,
        id_chofer:null,
        uuid_rendicion:null
      },
      setNotificacion
    );
  }

  return (
    <div>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            props.setOpen(false);
          }}
          severity={notificacion.severity}
        />
      ) : null}
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.setOpen(false)}
        maxWidth="sm"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Reabrir Pedido N° {datosformulario.id}
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent sx={{alignContent:"center"}}>
          <Typography textAlign={"center"}>
              ¿Desea Reabrir el Pedido N° {datosformulario.id}?
          </Typography>
          <Grid
            mt={1}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              variant="contained"
              onClick={() => props.setOpen(false)}
              color="error"
            >
              Volver
            </Button>
            <Button
              disabled={disBtn}
              variant="contained"
              onClick={guardarReabierto}
              color="success"
            >
              Guardar
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default ReabrirPedido